import * as React from 'react';
var DrawerContext = /*#__PURE__*/React.createContext(null);
export default DrawerContext;